import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialNotificationRepositoryService extends BaseRepositoryService<
  ModelRegistry['airbnb-official-notification']
> {
  recordName = 'airbnb-official-notification';
  implementMethods = ['unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-official-notification': AirbnbOfficialNotificationRepositoryService;
  }
}
